import { ImportModule } from "../helpers/importsHelper";
import MainAsianEventsLayoutDesktopHOC from "../screens/AsianEventsScreen/layouts/MainAsianEventsLayoutDesktop/MainAsianEventsLayoutDesktop";
import MainEventsLayoutDesktopHOC from "../screens/EventsScreen/layouts/MainEventsLayoutDesktop/MainEventsLayoutDesktop";
import MainHelpAndLearningLayoutDesktopHOC from "../screens/EventsScreen/layouts/MainEventsLayoutDesktop/MainHelpAndLearningLayoutDesktop";
// Use HOC to define a shared layout for the desktop screens
export const HOC = {
  AsianEventsScreenDesktop: MainAsianEventsLayoutDesktopHOC(
    ImportModule.AsianCompetitionsScreen
  ) as any,
  AsianReportsScreenDesktop: MainAsianEventsLayoutDesktopHOC(
    ImportModule.ReportsScreen
  ) as any,
  AsianAccountScreenDesktop: MainAsianEventsLayoutDesktopHOC(
    ImportModule.ProfileScreen
  ) as any,
  AsianAccountVerificationScreenDesktop: MainAsianEventsLayoutDesktopHOC(
    ImportModule.AccountVerificationScreen
  ) as any,
  AsianManageFundingScreenDesktop: MainAsianEventsLayoutDesktopHOC(
    ImportModule.ManageFundingScreen
  ) as any,
  AsianHelpAndLearningScreenDesktop: MainAsianEventsLayoutDesktopHOC(
    ImportModule.HelpAndLearningScreen
  ) as any,
  AsianHelpAndLearningWelcomeHelpAndLearningScreenDesktop:
    MainAsianEventsLayoutDesktopHOC(
      ImportModule.HelpAndLearningWelcomeHelpAndLearning
    ) as any,
  AsianHelpAndLearningGettingStartedFundingYourAccountScreenDesktop:
    MainAsianEventsLayoutDesktopHOC(
      ImportModule.HelpAndLearningGettingStartedFundingYourAccount
    ) as any,
  AsianHelpAndLearningGettingStartedPlacingABetScreenDesktop:
    MainAsianEventsLayoutDesktopHOC(
      ImportModule.HelpAndLearningGettingStartedPlacingABet
    ) as any,
  AsianHelpAndLearningGettingStartedOurOddsScreenDesktop:
    MainAsianEventsLayoutDesktopHOC(
      ImportModule.HelpAndLearningGettingStartedOurOdds
    ) as any,
  AsianHelpAndLearningGettingStartedQuickLinksScreenDesktop:
    MainAsianEventsLayoutDesktopHOC(
      ImportModule.HelpAndLearningGettingStartedQuickLinks
    ) as any,
  AsianHelpAndLearningRulesAndRegulationsSportsRules:
    MainAsianEventsLayoutDesktopHOC(
      ImportModule.HelpAndLearningRulesAndRegulationsSportsRules
    ) as any,
  AsianHelpAndLearningRulesAndRegulationsMarketRules:
    MainAsianEventsLayoutDesktopHOC(
      ImportModule.HelpAndLearningRulesAndRegulationsMarketRules
    ) as any,
  AsianHelpAndLearningRulesAndRegulationsCodeOfConduct:
    MainAsianEventsLayoutDesktopHOC(
      ImportModule.HelpAndLearningRulesAndRegulationsCodeOfConduct
    ) as any,
  AsianHelpAndLearningContactAndSupportContactUs:
    MainAsianEventsLayoutDesktopHOC(
      ImportModule.HelpAndLearningContactAndSupportContactUs
    ) as any,
  AsianHelpAndLearningFaqsMyAccountScreenDesktop:
    MainAsianEventsLayoutDesktopHOC(
      ImportModule.HelpAndLearningFaqsMyAccount
    ) as any,
  AsianHelpAndLearningFaqsFundingScreenDesktop: MainAsianEventsLayoutDesktopHOC(
    ImportModule.HelpAndLearningFaqsFunding
  ) as any,
  AsianHelpAndLearningFaqsBettingScreenDesktop: MainAsianEventsLayoutDesktopHOC(
    ImportModule.HelpAndLearningFaqsBetting
  ) as any,
  AsianHelpAndLearningAboutUsLicenceInformationScreenDesktop:
    MainAsianEventsLayoutDesktopHOC(
      ImportModule.HelpAndLearningAboutUsLicenceInformation
    ) as any,
  AsianHelpAndLearningResponsibleGamingScreenDesktop:
    MainAsianEventsLayoutDesktopHOC(
      ImportModule.HelpAndLearningResponsibleGaming
    ) as any,
  AsianHelpAndLearningSelfExclusionScreenDesktop:
    MainAsianEventsLayoutDesktopHOC(
      ImportModule.HelpAndLearningSelfExclusion
    ) as any,
  AsianHelpAndLearningTermsAndConditionsScreenDesktop:
    MainAsianEventsLayoutDesktopHOC(
      ImportModule.HelpAndLearningTermsAndConditions
    ) as any,
  AsianHelpAndLearningTermsAndConditionsPrivacyPolicyScreenDesktop:
    MainAsianEventsLayoutDesktopHOC(
      ImportModule.HelpAndLearningTermsAndConditionsPrivacyPolicy
    ) as any,
  AsianOpenBetsScreen: MainAsianEventsLayoutDesktopHOC(
    ImportModule.AsianOpenBetsScreen
  ) as any,
  AsianFunding: MainAsianEventsLayoutDesktopHOC(
    ImportModule.AsianFunding
  ) as any,
  AsianStatementScreen: MainAsianEventsLayoutDesktopHOC(
    ImportModule.AsianStatementScreen
  ) as any,
  AsianProfileScreenDesktop: MainAsianEventsLayoutDesktopHOC(
    ImportModule.ProfileScreen
  ) as any,
  EventsScreenDesktop: MainEventsLayoutDesktopHOC(
    ImportModule.CompetitionsScreenWrapper
  ) as any,
  PromoCategory: MainEventsLayoutDesktopHOC(
    ImportModule.CompetitionsScreenWrapper
  ) as any,
  EventFavoritesScreenDesktop: MainEventsLayoutDesktopHOC(
    ImportModule.EventFavoritesScreen
  ) as any,
  ManageFundingScreenDesktop: MainEventsLayoutDesktopHOC(
    ImportModule.ManageFundingScreen
  ) as any,
  ProfileScreenDesktop: MainEventsLayoutDesktopHOC(
    ImportModule.ProfileScreen
  ) as any,
  AsianAccountDesktop: MainAsianEventsLayoutDesktopHOC(
    ImportModule.AccountScreen
  ) as any,
  AccountScreenDesktop: MainEventsLayoutDesktopHOC(
    ImportModule.AccountScreen
  ) as any,
  AccountVerificationScreenDesktop: MainEventsLayoutDesktopHOC(
    ImportModule.AccountVerificationScreen
  ) as any,
  AccountControlsScreenDesktop: MainEventsLayoutDesktopHOC(
    ImportModule.AccountControlsScreen
  ) as any,
  HelpAndLearningScreensDesktop: MainHelpAndLearningLayoutDesktopHOC(
    ImportModule.HelpAndLearningScreen
  ) as any,
  HelpAndLearningWelcomeHelpAndLearningScreenDesktop:
    MainHelpAndLearningLayoutDesktopHOC(
      ImportModule.HelpAndLearningWelcomeHelpAndLearning
    ) as any,
  HelpAndLearningGettingStartedFundingYourAccountScreenDesktop:
    MainHelpAndLearningLayoutDesktopHOC(
      ImportModule.HelpAndLearningGettingStartedFundingYourAccount
    ) as any,
  HelpAndLearningGettingStartedPlacingABetScreenDesktop:
    MainHelpAndLearningLayoutDesktopHOC(
      ImportModule.HelpAndLearningGettingStartedPlacingABet
    ) as any,
  HelpAndLearningGettingStartedOurOddsScreenDesktop:
    MainHelpAndLearningLayoutDesktopHOC(
      ImportModule.HelpAndLearningGettingStartedOurOdds
    ) as any,
  HelpAndLearningGettingStartedQuickLinksScreenDesktop:
    MainHelpAndLearningLayoutDesktopHOC(
      ImportModule.HelpAndLearningGettingStartedQuickLinks
    ) as any,
  HelpAndLearningRulesAndRegulationsCodeOfConductScreenDesktop:
    MainHelpAndLearningLayoutDesktopHOC(
      ImportModule.HelpAndLearningRulesAndRegulationsCodeOfConduct
    ) as any,
  HelpAndLearningContactAndSupportContactUsScreenDesktop:
    MainHelpAndLearningLayoutDesktopHOC(
      ImportModule.HelpAndLearningContactAndSupportContactUs
    ) as any,
  HelpAndLearningFaqsMyAccountScreenDesktop:
    MainHelpAndLearningLayoutDesktopHOC(
      ImportModule.HelpAndLearningFaqsMyAccount
    ) as any,
  HelpAndLearningFaqsFundingScreenDesktop: MainHelpAndLearningLayoutDesktopHOC(
    ImportModule.HelpAndLearningFaqsFunding
  ) as any,
  HelpAndLearningAboutUsLicenceInformationScreenDesktop:
    MainHelpAndLearningLayoutDesktopHOC(
      ImportModule.HelpAndLearningAboutUsLicenceInformation
    ) as any,
  HelpAndLearningFaqsBettingScreenDesktop: MainHelpAndLearningLayoutDesktopHOC(
    ImportModule.HelpAndLearningFaqsBetting
  ) as any,
  HelpAndLearningRulesAndRegulationsSportsRulesScreenDesktop:
    MainHelpAndLearningLayoutDesktopHOC(
      ImportModule.HelpAndLearningRulesAndRegulationsSportsRules
    ) as any,
  HelpAndLearningRulesAndRegulationsMarketRulesScreenDesktop:
    MainHelpAndLearningLayoutDesktopHOC(
      ImportModule.HelpAndLearningRulesAndRegulationsMarketRules
    ) as any,
  HelpAndLearningResponsibleGamingScreenDesktop:
    MainHelpAndLearningLayoutDesktopHOC(
      ImportModule.HelpAndLearningResponsibleGaming
    ) as any,
  HelpAndLearningSelfExclusionScreenDesktop:
    MainHelpAndLearningLayoutDesktopHOC(
      ImportModule.HelpAndLearningSelfExclusion
    ) as any,
  HelpAndLearningTermsAndConditionsScreenDesktop:
    MainHelpAndLearningLayoutDesktopHOC(
      ImportModule.HelpAndLearningTermsAndConditions
    ) as any,
  HelpAndLearningTermsAndConditionsPrivacyPolicyScreenDesktop:
    MainHelpAndLearningLayoutDesktopHOC(
      ImportModule.HelpAndLearningTermsAndConditionsPrivacyPolicy
    ) as any,
};
